export default __webpack_public_path__ + "static/media/candles.771bfeaa.jpg";